/* Mr. Airco – eigen winkelwagen-drawer + winkelwagenpagina */
(function () {
  'use strict';
  if (window.__mraCart) return; window.__mraCart = true;

  var cd = function () { return document.querySelector('[data-mra-cd]'); };
  var busy = false;
  var origFetch = window.fetch.bind(window);

  // Dawn-drawer uitschakelen zodat alles via onze drawer loopt
  function killDawn() {
    document.querySelectorAll('cart-drawer, #CartDrawer').forEach(function (el) { el.remove(); });
  }

  function open() {
    var d = cd(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mra-noscroll');
    var p = d.querySelector('.mra-cd__panel'); if (p) setTimeout(function () { p.focus(); }, 50);
  }
  function close() {
    var d = cd(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mra-noscroll');
  }
  window.mraCartOpen = open;

  function setCount(n) {
    document.querySelectorAll('[data-mra-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    document.querySelectorAll('[data-mra-cd-count]').forEach(function (el) { el.textContent = n || ''; });
  }

  // Alle cart-blokken op de pagina verversen via de Section Rendering API
  function refresh() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-mra-cx-root]'));
    var ids = roots.map(function (r) { return r.getAttribute('data-mra-cx-root'); });
    if (!ids.length) return Promise.resolve();
    var u = new URL(window.location.href); u.hash = ''; u.searchParams.set('sections', ids.join(',')); u.searchParams.set('_', Date.now());
    // Geen Accept: application/json, anders geeft Shopify op /cart, /products en /collections de JSON van die pagina terug
    return origFetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        roots.forEach(function (root) {
          var html = json[root.getAttribute('data-mra-cx-root')]; if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-mra-cx-root]');
          root.innerHTML = inner ? inner.innerHTML : (doc.body.firstElementChild && doc.body.firstElementChild.classList.contains('shopify-section') ? doc.body.firstElementChild.innerHTML : doc.body.innerHTML);
        });
        if (window.mraApplyBtw) window.mraApplyBtw();
        document.dispatchEvent(new CustomEvent('mra:cart-updated'));
        return origFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      });
  }
  window.mraCartRefresh = refresh;

  function setBusy(el, on) {
    busy = on;
    var item = el && el.closest('.mra-cx-item, .mra-cx-upi'); if (item) item.classList.toggle('is-busy', on);
  }

  // Elke geslaagde /cart/add (ook van andere scripts) opent de drawer
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !(init && init.__mra)) {
      p.then(function (r) { if (r.ok) { refresh().then(function () { if (!document.querySelector('[data-mra-cx-page-root]')) open(); }); } }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    // cart-links openen de drawer i.p.v. de pagina
    var link = e.target.closest('[data-mra-cart-link], a[href="/cart"], a[href="' + ((window.routes && window.routes.cart_url) || '/cart') + '"]');
    if (link && !link.hasAttribute('data-mra-cx-page') && !document.querySelector('[data-mra-cx-page-root]') && cd()) {
      e.preventDefault(); open(); return;
    }
    if (e.target.closest('[data-mra-cd-close]')) { e.preventDefault(); close(); return; }

    var q = e.target.closest('[data-mra-cx-qty]');
    if (q && !busy) {
      e.preventDefault();
      var line = q.closest('[data-mra-line]'); if (!line) return;
      setBusy(q, true);
      origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.getAttribute('data-mra-line'), quantity: Number(q.getAttribute('data-mra-cx-qty')) }) })
        .then(function (r) { if (!r.ok) throw new Error('change'); return refresh(); })
        .catch(function () { return refresh(); }).then(function () { setBusy(q, false); });
      return;
    }
    var a = e.target.closest('[data-mra-cx-add]');
    if (a && !busy) {
      e.preventDefault(); setBusy(a, true);
      origFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(a.getAttribute('data-mra-cx-add')), quantity: 1 }] }) })
        .then(refresh).catch(function () {}).then(function () { setBusy(a, false); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function init() {
    killDawn();
    // terug van checkout met #cart of ?open_cart opent direct
    if (/[?&#]open_cart/.test(location.href)) open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
